import DocumentEditorController from '../entrypoints/src/admin/editor/document_editor_base';

// Contract editor: a document editor whose merge-tag set is fixed (the enrollment
// contract dictionary, serialized into data-variables on the container).
export default class extends DocumentEditorController {
  connect() {
    this.variables = JSON.parse(this.element.dataset.variables || '[]');
    this.mountDocumentEditors();
  }

  disconnect() {
    this.teardownEditors();
  }

  contractGroups() {
    return this.variables;
  }
}
